import * as React from "react";
import { FieldValidationProps } from "../../Redux/Form/components/Field";
import { ValidationLabel } from "../../sharedComponents/validation/ValidationLabel";

export interface WithValidationProps {
    validation?: FieldValidationProps;
    validationThemes?: string;
    disabled?: boolean;
    //Note: this for hidding validation message only
    hideErrorMsg?: boolean;
    //Note: this for not displaying validation at all
    hideValidation?: boolean;
}

export interface ComponentValidationProps {
    invalid?: boolean;
    showValidation?: boolean;
}

export const withValidation = <P extends {}>(UnwrappedComponent: React.ComponentType<P & ComponentValidationProps>) =>
    class WithValidation extends React.Component<P & WithValidationProps> {
        constructor(props: P & WithValidationProps) {
            super(props);

            this.shouldShowValidation = this.shouldShowValidation.bind(this);
            this.isValueValid = this.isValueValid.bind(this);
        }

        isValueValid() {
            const { validation, disabled } = this.props;
            return !disabled && validation && !validation.isValid;
        }

        shouldShowValidation() {
            const { validation, disabled } = this.props;
            return !disabled && validation && validation.needToShowErrors && !this.props.hideValidation;
        }

        shouldShowErrorMsg() {
            return !this.props.hideErrorMsg && this.shouldShowValidation();
        }

        render() {
            const { validation, validationThemes } = this.props;
            return (
                <>
                    <UnwrappedComponent
                        {...this.props}
                        invalid={this.isValueValid()}
                        aria-invalid={this.isValueValid()}
                        showValidation={this.shouldShowValidation()}
                    />
                    {this.shouldShowErrorMsg() && <ValidationLabel text={validation.error} theme={validationThemes} />}
                </>
            );
        }
    };
